import { Component, Inject, Input, OnInit } from '@angular/core';

import { APP_CONFIG, IAppConfig } from '../config/app.config';
import { PanelNavElementComponent } from './panel-nav-element/panel-nav-element.component';
import { ActivatedRoute, NavigationEnd, Params, Router } from '@angular/router';

@Component({
    selector: 'panel-nav',
    templateUrl: './panel-nav.component.html',
    styleUrls: ['./panel-nav.component.css'],
    standalone: false
})
export class PanelNavComponent implements OnInit {
  public officeTab = false;
  public terminalTab = false;
  @Input()
  public panelId: string;

  @Input()
  public officeId: string;

  @Input()
  public officeType: string = '1A';

  @Input()
  public isEditMode: boolean = false;

  @Input()
  public draftId: string;

  @Input()
  public isCreateFlow: boolean = false;

  @Input()
  public vendor: string;

  @Input()
  public isReplicateFlow: boolean = false;

  @Input()
  public org: string;

  @Input()
  public flowType: string;

  public panels: any;

  constructor(
    private router: Router,
    @Inject(APP_CONFIG) private config?: IAppConfig,
  ) {
    this.panels = this.config.panels;
  }

  public ngOnInit() {
    // init
    const user = sessionStorage.getItem('user');
    if (user) {
      const userObj = JSON.parse(user);
      this.officeTab =
        userObj && userObj.security && userObj.security.officeTab;
      this.terminalTab =
        userObj && userObj.security && userObj.security.terminalAndPrinterTab;
    }
  }

  public goToOffice() {
    this.router.navigate(['/office']);
  }
  public getTerminalData() {
    this.navigateTPA('TERMINAL', 'T');
  }

  public getPrinterData() {
    this.navigateTPA('PRINTER', 'P');
  }

  public getPrinterSetData() {
    this.navigateTPA('SET', 'Q');
  }

  public getCIDData() {
    this.navigateTPA('CERTIFICATE', 'W');
  }

  public getCertHistoryData() {
    this.navigateTPA('CERTHISTORY', 'Z');
  }
  public isDevicesScreen() {
    const devicePanels = ['T', 'P', 'Q', 'W', 'Z'];
    return devicePanels.indexOf(this.panelId) !== -1 ? true : false;
  }

  private navigateTPA(deviceType: string, panel: string) {
    deviceType = deviceType.toUpperCase();
    switch (this.officeType) {
      case 'NS':
        if (this.officeId) {
          // do something
          const officeSpit = this.officeId.split('_');
          this.router.navigate(['/tpa/result/'], {
            queryParams: {
              type: this.officeType,
              office: officeSpit[0] + '_' + officeSpit[1],
              panelId: panel,
              device: deviceType,
              officeSet: '1'
            },
          });
        }
        break;
      case '1A':
        this.router.navigate(['/tpa/result/'], {
          queryParams: {
            type: this.officeType,
            office: this.officeId,
            panelId: panel,
            device: deviceType,
            officeSet: '1'
          },
        });
        break;
      case 'AMID':
        this.router.navigate(['/tpa/result/'], {
          queryParams: {
            type: this.officeType,
            office: this.officeId,
            panelId: panel,
            device: deviceType,
            officeSet: '1'
          },
        });
        break;
      default:
      // do nothing
    }
  }
}
